import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import { ArrowLeft, Desktop, Tablet, Phone } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import { isSaaSAdmin } from '@/redux/util';
import './WidgetBuilderHeader.scss';

const WidgetBuilderHeader = props => {
	const { page, handleSubmit, event, preview, setPreview, hasChanges, isSaving } = props;
	const navigate = useNavigate();
	const pageName = page ? page.name : 'Homescreen';

	const handleRedirect = location => {
		if (location === 'pages') navigate(`/events/${event.id}/pages`);
		else if (location === 'standardBuilder')
			page
				? navigate(`/events/${event.id}/pages/${page.id}`, { state: { showStandardBuilder: true } })
				: navigate(`/events/${event.id}/home`);
	};

	const toggleOptions = [
		{
			icon: <Desktop />,
			name: 'desktop',
		},
		{
			icon: <Tablet />,
			name: 'tablet',
		},
		{
			icon: <Phone />,
			name: 'phone',
		},
	];
	return (
		<div className="WidgetBuilderHeader">
			<div className="header-title">
				{page ? <ArrowLeft onClick={() => handleRedirect('pages')} /> : null}
				<span className="header-text">{pageName}</span>
			</div>
			<div className="header-toggle">
				<Toggle toggleOptions={toggleOptions} value={preview} onChange={setPreview} />
			</div>
			<div className="header-buttons">
				{!isSaaSAdmin() ? (
					<>
						<Button
							onClick={() => handleRedirect('standardBuilder')}
							className="header-button full"
						>
							Standard Builder
						</Button>
						<Button
							onClick={() => handleRedirect('standardBuilder')}
							className="header-button short"
						>
							Standard
						</Button>
					</>
				) : null}
				<Button
					onClick={handleSubmit}
					disabled={isSaving}
					className="header-button full"
					style={{
						backgroundColor: hasChanges ? '#d32463' : '#e0f2ff',
						color: hasChanges ? 'white' : '#00108e',
					}}
				>
					{isSaving ? 'Saving...' : 'Save Page'}
				</Button>
				<Button onClick={handleSubmit} disabled={isSaving} className="header-button short">
					{isSaving ? 'Saving...' : 'Save'}
				</Button>
			</div>
		</div>
	);
};

export default WidgetBuilderHeader;
